import { render, staticRenderFns } from "./RecordTypeListContainer.vue?vue&type=template&id=4a59f3f1&scoped=true"
import script from "./RecordTypeListContainer.vue?vue&type=script&lang=js"
export * from "./RecordTypeListContainer.vue?vue&type=script&lang=js"
import style0 from "./RecordTypeListContainer.vue?vue&type=style&index=0&id=4a59f3f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a59f3f1",
  null
  
)

export default component.exports